import { combineReducers } from "redux";
import privacypolicy from "../features/admin/contain/privacypolicy/Slice";
import termscondition from "../features/admin/contain/termsandcondition/Slice";
import contactus from "../features/admin/contain/contactus/Slice";
import appsetup from "../features/admin/contain/appsetup/Slice" 
const contain = combineReducers({

  privacypolicy:privacypolicy,
  termscondition:termscondition,
  contactus:contactus,
  appsetup:appsetup,

  
});


export default contain;